import React from 'react'
import { Flex, Text, Box } from '@chatterbug/aaron'

const FooterRowItem = ({ number, label }) => {
  return (
    <Flex flexDirection="column" lineHeight="s">
      <Box as="h5" variant="text.h5">
        {number}
      </Box>
      <Text fontSize="xs" fontWeight="medium" color="gray60" mt="0,25x">
        {label}
      </Text>
    </Flex>
  )
}

export default FooterRowItem
